import { render, staticRenderFns } from "./zoopla.vue?vue&type=template&id=78c64ae0&scoped=true&"
import script from "./zoopla.vue?vue&type=script&lang=js&"
export * from "./zoopla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c64ae0",
  null
  
)

export default component.exports